import React, {useState, useEffect, useCallback, useRef} from "react";
import './../../App.css';
import './Transactions.css';
import { useTable, useSortBy } from "react-table";
import * as XLSX from 'xlsx'; // Import all exports from xlsx library
import loadingSpinner from './../../assets/loading.gif';
import {token, domain, globalTimeFormat} from '../Security';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from 'axios';
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AddIcon from '@mui/icons-material/Add';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DownloadIcon from '@mui/icons-material/Download';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import PostAddIcon from '@mui/icons-material/PostAdd';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DoneIcon from '@mui/icons-material/Done';
import ChecklistIcon from '@mui/icons-material/Checklist';

function DTRCorrectionWorkers({user, userAccess, isHideSideMenu}) {
    var uploadTimeEntriesHeader = [
        "Id",
        "Employee Id",
        "Employee",
        "Classification",
        "Date",
        "Time In",
        // "Device",
        "Time Out",
        // "Device",
        "Shift Name",
        "Reason for Tampering",
        "Approved?",
        "",
    ]
    var uploadTimeEntriesaccessor = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "date",
        "timeIn",
        // "deviceNameTimeIn",
        "timeOut",
        // "deviceNameTimeOut",
        "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
        "reasonForTampering",
        "isApproved",
        "manage"
    ]

    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null); 

    const [dateTimeRecordData, setDateTimeRecordData] = useState([]);
    const [dateTimeRecordDataProcessed, setDateTimeRecordDataProcessed] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataProcessed, setFilterDataProcessed] = useState([]);
    const [selectedDTR, setSelectedDTR] = useState([]);
    const [activeRowIds, setActiveRowIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const [showRevertTimeForm, setShowRevertTimeForm] = useState(false);
    const [showProcessTimeForm, setShowProcessTimeForm] = useState(false);
    const [showPostTimeForm, setShowPostTimeForm] = useState(false);
    const [showDeleteAll, setShowDeleteAll] = useState(false);

    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [date, setDate] = useState("");
    const [timeIn, setTimeIn] = useState("");
    const [deviceNameTimeIn, setDeviceNameTimeIn] = useState("");
    const [timeOut, setTimeOut] = useState("");
    const [deviceNameTimeOut, setDeviceNameTimeOut] = useState("");
    const [reasonForTampering, setReasonForTampering] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [dataToEdit, setDataToEdit] = useState([]);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [dataToDelete, setDataToDelete] = useState([]);
    
    //Approve
    const [showApproveForm, setShowApproveForm] = useState(false);
    const [isSelectAll, setIsSelectAll] = useState(false);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

        setDateTimeRecordData(res);
    };

    const handleFilterProcessed = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterDataProcessed.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

        setDateTimeRecordDataProcessed(res);
    };

    const apiUrl =  domain + "/api/DTRCorrectionWorkerStaging";
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            timeIn: timeIn,
            deviceNameTimeIn: deviceNameTimeIn,
            timeOut: timeOut,
            deviceNameTimeOut: deviceNameTimeOut,
            reasonForTampering: reasonForTampering,
            date: timeIn.split('T')[0],
            createdById: user.id,
            createdDate: new Date(),
        };

        try {
            setShowAddForm(false); // Hide the add form
            setLoading(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await fetchDataTimeEntries(); // Assuming fetchData() fetches the updated data for the table
            await fetchDataProcessed(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationFullName("");
            setTimeIn("");
            setDeviceNameTimeIn("");
            setTimeOut("");
            setDeviceNameTimeOut("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            date: date,
            timeIn: timeIn,
            deviceNameTimeIn: deviceNameTimeIn,
            timeOut: timeOut,
            deviceNameTimeOut: deviceNameTimeOut,
            reasonForTampering: reasonForTampering,
            createdById: dataToEdit.createdById,
            createdDate: dataToEdit.createdDate,
            updatedById: user.id,
            updatedDate: new Date()
        };

        try {
            setLoading(true);
            await axios.put(apiUrl + `/${dataToEdit.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowEditForm(false); // Hide the add form
            await fetchDataTimeEntries(); // Assuming fetchData() fetches the updated data for the table
            await fetchDataProcessed(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }

        setShowEditForm(false);
    };
    const handleDelete = async () => {
        try {
            setLoading(true);
            await axios.delete(apiUrl + `/${dataToDelete.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowDeleteForm(false);
            
            await fetchDataTimeEntries(); // Assuming fetchData() fetches the updated data for the table
            await fetchDataProcessed(); // Assuming fetchData() fetches the updated data for the table

            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setDataToDelete("");
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }
        
        setShowDeleteForm(false);
    };
    const handleFileUpload= async (files) => {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        setLoading(true);

        const employees = await fetchAllEmployees();
        
        const file = files[0];
        let finalData = [];
        
        parseExcelFile(file)
        .then(async (data) => {
            let isError = false;
            setLoading(false);

            data.forEach((entry) => {
                let errorMsg = "";
                for (let i = 0; i < Object.keys(entry).length; i++) {
                    const header = Object.keys(entry)[i];
                    const values = Object.values(entry)[i];
                    
                    if(values === null 
                        || values === undefined
                        || values === ""
                    ){
                        if(header !== "deviceNameTimeIn" 
                        && header !== "deviceNameTimeOut" 
                        && header !== "timeIn" 
                        && header !== "timeOut" 
                        ) {
                            errorMsg = "Has an empty value. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "employeePersonalInformationEmployeeId"){
                        const foundEmployee = employees.find(employee => employee.employeeId.toString() === values.toString());
                        if(!foundEmployee){
                            errorMsg = errorMsg + "Invalid employee id. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "date"){
                        if(!isValidDateFormat(values) && values){
                            errorMsg = errorMsg + "Date should be mm/dd/yyyy format. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "timeIn" || header === "timeOut"){
                        if(!isValidTimeFormat(values) && values){
                            errorMsg = errorMsg + "Time should be hh:mm AM/PM format. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }
                }

                const newErrorData = {
                    employeePersonalInformationEmployeeId: entry.employeePersonalInformationEmployeeId,
                    employeePersonalInformationFullName: entry.employeePersonalInformationFullName,
                    date: isValidDateFormat(entry.date) ? entry.date : entry.date,
                    timeIn: isValidTimeFormat(entry.timeIn) ? entry.timeIn : entry.timeIn,
                    timeOut: isValidTimeFormat(entry.timeOut) ? entry.timeOut : entry.timeOut,
                    reasonForTampering: entry.reasonForTampering,
                    error: errorMsg 
                };

                setErrorData(prevErrorData => [...prevErrorData, newErrorData]);
            });

            if(isError) {
                return;
            }

            data.forEach((entry) => {
                const foundEmployee = employees.find(employee => employee.employeeId.toString() === entry.employeePersonalInformationEmployeeId.toString());

                const _data = {
                    employeePersonalInformationId: foundEmployee.id, 
                    employeePersonalInformationEmployeeId: entry.employeePersonalInformationEmployeeId.toString(), 
                    employeePersonalInformationFullName: entry.employeePersonalInformationFullName, 
                    date: entry.date ? combineDateTimeToLocal(entry.date, "00:00 AM") : null, 
                    timeIn: entry.timeIn ? combineDateTimeToLocal(entry.date, entry.timeIn) : null, 
                    timeOut: entry.timeOut ? combineDateTimeToLocal(entry.date, entry.timeOut) : null, 
                    reasonForTampering: entry.reasonForTampering ? entry.reasonForTampering : null,
                    createdDate: new Date()
                };

                finalData.push(_data);
            });

            const apiUrl =  domain + "/api/DTRCorrectionWorkerStaging/bulk";

            try {
                axios.post(apiUrl, finalData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })
                setTimeout(async () => {
                    await fetchDataTimeEntries();
                    await fetchDataProcessed();
                }, 1000);
                
                setShowRequestMessage(true);
                setIsSuccess(true);
                setIsErrorUpload(false);
                setErrorData([]);
            } catch (error) {
                console.error('Error posting data to API:', error);
                setShowRequestMessage(true);
                setIsSuccess(false);
                
                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                    setRequestMessage(errorMessage);
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message; // Fallback to general message
                    setRequestMessage(errorMessage);
                } else {
                    setRequestMessage("An unknown error occurred."); // Default message
                }
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error('Error parsing Excel file:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            if (error.response && error.response.data && error.response.data.errors) {
                const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                setRequestMessage(errorMessage);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message; // Fallback to general message
                setRequestMessage(errorMessage);
            } else {
                setRequestMessage("An unknown error occurred."); // Default message
            }
        });
    }
    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    const [errorData, setErrorData] = useState([]);
    const [isErrorUpload, setIsErrorUpload] = useState(false);
    const fetchAllEmployees = async () => {
        const apiUrl =  domain + "/api/Employee/single-data";
        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };
    function isValidDateFormat(date) {
        // Regex allows single or double-digit MM/DD
        const dateRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;
    
        return dateRegex.test(date);
    }
    function isValidTimeFormat(time) {
        // Regular expression for the time format hh:mm AM/PM
        const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(?:AM|PM)$/i;
    
        // Test if the time matches the regular expression
        return timeRegex.test(time);
    }
    const generateDownloadTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        setLoading(true);

        const employees = await fetchDataEmployeesByTimeKeeper();

        const header = ['EmployeeId', 'EmployeeName', 'Date', 'TimeIn', 'TimeOut', 'ReasonForTampering'];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'timeIn', width: 30 },
            { key: 'timeOut', width: 30 }, 
            { key: 'reasonForTampering', width: 30 }, 
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        employees.forEach((item) => {
            worksheet.addRow([
                item.employeeId,
                item.employeeFullName,
                formatDate(new Date()),
                '<hh:mm AM/PM>',
                '<hh:mm AM/PM>',
                "<REQUIRED TO FILL>",
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'DTRTemplate.xlsx');

        setLoading(false);
    };

    function formatDate(dateString) {
        if(!dateString){
            return '';
        }
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    
    function formatTime(time) {
        if(!time){
            return '';
        }

        const timePart = time.split('T')[1];
        if (timePart) {
            const [hour, minute] = timePart.split(':');
            const hours = parseInt(hour, 10);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;

            return `${formattedHours}:${minute} ${ampm}`;
        }
    }


    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'Employee Id',
            'Name',
            'Date',
            'Time In',
            'Time Out',
            'Shift Name',
            'Reason For Tampering'
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'timeIn', width: 30 },
            { key: 'timeOut', width: 30 },
            { key: 'employeePersonalInformationEmployeeInformationShiftScheduleShiftName', width: 30 },
            { key: 'reasonForTampering', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const sortedData = [...dateTimeRecordData].sort((a, b) => {
            // Sort by Name first
            if (a.employeePersonalInformationFullName < b.employeePersonalInformationFullName) return -1;
            if (a.employeePersonalInformationFullName > b.employeePersonalInformationFullName) return 1;
        
            // If Name is the same, sort by Date
            return new Date(a.date) - new Date(b.date);
        });
    
        sortedData.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                formatDate(item.date),
                formatTime(item.timeIn),
                formatTime(item.timeOut),
                item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName,
                item.reasonForTampering,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'TimeEntries.xlsx');
    };
    function s2ab(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }
    function parseExcelFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
        
            reader.onload = (e) => {
                try {
                    const binaryString = e.target.result;
                    const workbook = XLSX.read(binaryString, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    
                    // Get all rows except the first one (header row)
                    const excelData = XLSX.utils.sheet_to_json(sheet, {
                        header: [
                        'employeePersonalInformationEmployeeId', 
                        'employeePersonalInformationFullName', 
                        'date', 
                        'timeIn', 
                        "timeOut", 
                        "reasonForTampering", 
                    ],
                        range: 1, 
                        defval: "" 
                    });

                    excelData.forEach(row => {
                        if (typeof row.date === 'number') {
                            const excelDate = row.date;
                            const date = new Date((excelDate - (25567 + 1)) * 86400 * 1000);
                            row.date = date.toLocaleDateString();
                        }
                        if (typeof row.timeIn === 'number') {
                            const excelTime = row.timeIn;
                            const millisecondsInDay = 24 * 60 * 60 * 1000;
                            const timeInMilliseconds = excelTime * millisecondsInDay;
                            const date = new Date(timeInMilliseconds);
                            row.timeIn = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); // Format time as desired
                        }
                        if (typeof row.timeOut === 'number') {
                            const excelTime = row.timeOut;
                            const millisecondsInDay = 24 * 60 * 60 * 1000;
                            const timeOutMilliseconds = excelTime * millisecondsInDay;
                            const date = new Date(timeOutMilliseconds);
                            row.timeOut = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); // Format time as desired
                        }
                    });
                    
                    resolve(excelData);
                } catch (error) {
                    reject(error);
                }
            };
        
            reader.readAsBinaryString(file);
        });
    }
    function combineDateTimeToLocal(date, time) {
        // Split date and time
        const [month, day, year] = date.split('/');
        const [timeWithoutAMPM, ampm] = time.split(' ');

        // Extract hours and minutes
        const [hours, minutes] = timeWithoutAMPM.split(':').map(Number);

        // Convert hours to 24-hour format if PM
        let adjustedHours = hours;
        if (ampm === 'PM' && hours !== 12) {
            adjustedHours += 12;
        } else if (ampm === 'AM' && hours === 12) {
            adjustedHours = 0;
        }

        // Combine date and time into datetime-local format
        const datetimeLocal = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${adjustedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

        return datetimeLocal;
    }
    const downloadError = useCallback((entries) => {
        const allData = [];
        
        entries.forEach(entry => {
            const data = [
                [entry.employeePersonalInformationEmployeeId, 
                    entry.employeePersonalInformationFullName, 
                    entry.date, 
                    entry.timeIn, 
                    entry.timeOut, 
                    entry.reasonForTampering, 
                    entry.error]
            ];

            allData.push(...data);
        });

        allData.unshift(['EmployeeId', 'EmployeeName', 'Date', 'TimeIn', 'TimeOut', 'ReasonForTampering', 'Error(NOTE: Please delete this column if you want to re-use this worksheet)']);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RegularDataSheet');

        const excelBuffer = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });

        const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'ErrorFile.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, []);
    const approveHandleClick = async () => {
        if (selectedDTR.length <= 0) {
            setShowRequestMessage(true);
            setRequestMessage("No selected record");
            setIsSuccess(false);
            closeApproveHandleClick();
            return;
        }
        
        setLoading(true);
        setShowApproveForm(false);

        try {
            await axios.put(apiUrl + `/approval-bulk`, selectedDTR, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Updated successfully');
            
            // Reload table data and reset state
            await fetchDataTimeEntries(); // Assuming fetchData() fetches the updated data for the table
            await fetchDataProcessed(); // Assuming fetchData() fetches the updated data for the table
            setLoading(false);
            setSelectedDTR([]);
            setActiveRowIds([]);
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating record:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    useEffect(() => {
        if(showEditForm){
            // setEmployeePersonalInformationEmployeeId(dataToEdit.employeePersonalInformationEmployeeId)
            setEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId)
            setEmployeePersonalInformationFullName(dataToEdit.employeePersonalInformationFullName)
            setTimeIn(dataToEdit.timeIn)
            setDate(dataToEdit.date)
            setDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
            setTimeOut(dataToEdit.timeOut)
            setDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
            setReasonForTampering(dataToEdit.reasonForTampering)
        }
    }, [showEditForm, 
        dataToEdit, 
    ]);

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setDataToEdit(data);
        setShowEditForm(true);
    };
    const deleteHandleClick = (data) => {
        setShowDeleteForm(true);
        setDataToDelete(data);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    };
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    const openRevertTimeForm = () =>{
        setShowRevertTimeForm(true);
    }
    const closeRevertTimeForm = () =>{
        setShowRevertTimeForm(false);
    }
    const openProcessTimeForm = () =>{
        setShowProcessTimeForm(true);
    }
    const closeProcessTimeForm = () =>{
        setShowProcessTimeForm(false);
    }
    const openPostTimeForm = () =>{
        setShowPostTimeForm(true);
    }
    const closePostTimeForm = () =>{
        setShowPostTimeForm(false);
    }
    const openDeleteAll = () =>{
        setShowDeleteAll(true);
    }
    const closeDeleteAll = () =>{
        setShowDeleteAll(false);
    }

    const closeApproveHandleClick = () => {
        setShowApproveForm(false);
    };

    useEffect(() => {
        if(isErrorUpload){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage('Please check the ErrorFile.xlsx');
            setIsErrorUpload(false);
            setErrorData([]);
            downloadError(errorData);
        }
    }, [isErrorUpload, downloadError, errorData]);

    const [isGenerateUploadedTimeEntries, setIsGenerateUploadedTimeEntries] = useState(false);
    const [payrollPeriodUploadedTimeEntries, setPayrollPeriodUploadedTimeEntries] = useState("");
    const [sectionFilter, setSectionFilter] = useState("0");
    const [locationFilter, setLocationFilter] = useState("0");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

    const [filterClassificationIdTimeEntries, setFilterClassificationIdTimeEntries] = useState("0");

    const generateUploadedTimeEntries = () => {
        setIsGenerateUploadedTimeEntries(true);
    }

    const fetchDataEmployeesByTimeKeeper = useCallback(async () => {
        const apiUrlFetch =  domain + `/api/Employee/employee-schedules/timekeeper/${user.employeePersonalInformationId}/classification/${0}/location/${0}`;

        try {
            const response = await axios.get(apiUrlFetch, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);

    const fetchDataTimeEntries = useCallback(async () => {
        if(!isGenerateUploadedTimeEntries){
            return;
        }

        let classificationFilter = filterClassificationIdTimeEntries;
        
        // const apiUrlFetch =  domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/section/${sectionFilter}`;
        const apiUrlFetch =  domain + `/api/DTRCorrectionWorkerStaging/timekeeper/${user.employeePersonalInformationId}/classification/${classificationFilter}/section/${sectionFilter}/location/${locationFilter}/payrollperiod/${payrollPeriodUploadedTimeEntries}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrlFetch, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})

                let filteredBySection = response.data;

                setCurrentClassificationFilter(classificationFilter);

                if(classificationFilter !== currentClassificationFilter){
                    setSectionFilter("0")
                    setLocationFilter("0")
                }

                let finalData = filteredBySection;
                setDateTimeRecordData(finalData); // Set the response data to the state
                setFilterData(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [
        currentClassificationFilter,
        filterClassificationIdTimeEntries,
        sectionFilter,
        locationFilter,
        user,
        isGenerateUploadedTimeEntries,
        payrollPeriodUploadedTimeEntries
    ]);
    const fetchDataProcessed = useCallback(async () => {
        if(!isGenerateUploadedTimeEntries){
            return;
        }

        let classificationFilter = filterClassificationIdTimeEntries;
        
        // const apiUrlFetch =  domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/section/${sectionFilter}`;
        const apiUrlFetch =  domain + `/api/DTRCorrectionWorker/classification/${classificationFilter}/section/${sectionFilter}/location/${locationFilter}/payrollperiod/${payrollPeriodUploadedTimeEntries}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrlFetch, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
                let filteredBySection = response.data;

                setCurrentClassificationFilter(classificationFilter);

                if(classificationFilter !== currentClassificationFilter){
                    setSectionFilter("0")
                    setLocationFilter("0")
                }

                let finalData = filteredBySection;
                setDateTimeRecordDataProcessed(finalData); // Set the response data to the state
                setFilterDataProcessed(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [
        currentClassificationFilter,
        filterClassificationIdTimeEntries,
        sectionFilter,
        locationFilter,
        isGenerateUploadedTimeEntries,
        payrollPeriodUploadedTimeEntries
    ]);

    useEffect(() => {
        fetchDataTimeEntries();
        fetchDataProcessed();
    }, [fetchDataTimeEntries, fetchDataProcessed])

    
    const [selectedTab, setSelectedTab] = useState(0);
    const handleSelectChange = (index) => {
        setSelectedTab(index);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TimeInfo">
                        <div className='sub-title row' style={{padding:"5px 20px"}}>
                            <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                            <span style={{borderBottom:"1px solid black"}}>{"DTR Correction Workers"}</span>
                        </div>
                        <div className="timeHeader row" style={{justifyContent:"space-between", alignItems:"center"}}>
                            <div className="tHeaderTitle row">
                                <AccessTimeFilledIcon style={{padding:"0 10px 0 0"}}/>
                                <h3>DTR Correction Workers</h3>
                            </div>
                            <div style={{width:"30%",textAlign:"right"}}>
                                <div style={{display: "none"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            user={user}
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            openDeleteFormHandleClick={openDeleteAll}
                                            openRevertTimeForm={openRevertTimeForm}
                                            openProcessTimeForm={openProcessTimeForm}
                                            openPostTimeForm={openPostTimeForm}
                                            />}
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div style={{padding:"10px"}}>
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "unset"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Payroll Period</div>
                                        <div className="info-item-input">
                                            <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodUploadedTimeEntries} setPayrollPeriodId={setPayrollPeriodUploadedTimeEntries} />
                                        </div>
                                    </div>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectWithAll1 classificationId={filterClassificationIdTimeEntries} setClassificationId={setFilterClassificationIdTimeEntries} setActiveRowIds={setActiveRowIds} setSelectedDTR={setSelectedDTR}/>
                                            </div>
                                        </div>
                                    { (filterClassificationIdTimeEntries.toString() === "3") &&
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Section</div>
                                            <div className="info-item-input">
                                                <SectionIdSelect sectionId={sectionFilter} setSectionId={setSectionFilter}/>
                                            </div>
                                        </div>
                                    }
                                    { (filterClassificationIdTimeEntries.toString() === "3") &&
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Location</div>
                                            <div className="info-item-input">
                                                <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                            </div>
                                        </div>
                                    }
                                    { (filterClassificationIdTimeEntries.toString() === "4") &&
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Location</div>
                                            <div className="info-item-input">
                                                <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", generateUploadedTimeEntries, "GENERATE", RestartAltIcon)}</div>
                            </div>
                        </div>
                        <div className="mainData">
                            <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)} style={{display: "none"}}>
                                <TabList>
                                    <Tab><b>UPLOADED ENTRIES</b></Tab>
                                    <Tab><b>PROCESSED ENTRIES</b></Tab>
                                </TabList>
                                <div className="timeKeepingTab">
                                    <TabPanel>
                                        <>
                                            <div style={{marginTop: "20px"}}>
                                                {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilter(e.target.value), 
                                                                        "Search by name", 
                                                                        SearchIcon)}
                                            </div>
                                            <div className="transaction-body" style={{padding: "0"}}>
                                                <>
                                                    <div className="timeBtns row">
                                                        <div className="timeBtn add row">
                                                            {CreateButton("", "icon row", addHandleClick, "ADD", AddIcon)}
                                                        </div>
                                                        <div className="timeBtn extract row">
                                                            {CreateButton("", "icon row", exportToExcel, "EXTRACT", FileCopyIcon)}
                                                        </div>
                                                        <div className="timeBtn download row">
                                                            {CreateButton("", "icon row", generateDownloadTemplate, "DOWNLOAD TEMPLATE", DownloadIcon)}
                                                        </div>
                                                        <div className="timeBtn extract row">
                                                            {CreateButton("", "icon row", openUploadFormHandleClick, "UPLOAD DTR", FileUploadIcon)}
                                                        </div>
                                                        <div className="timeBtn delete row">
                                                            {CreateButton("", "icon row", openDeleteAll, "DELETE DTR", DeleteForeverIcon)}
                                                        </div>
                                                        <div className="timeBtn download row">
                                                            {CreateButton("", "icon row", openPostTimeForm, "POST DTR", PostAddIcon)}
                                                        </div>
                                                        <div className="timeBtn approve row" style={{display: "none"}}>
                                                            {CreateButton("", "icon row", ()=>setShowApproveForm(true), "APPROVE", DoneIcon)}
                                                        </div>
                                                        <div className="timeBtn approve row" style={{display: "none"}}>
                                                            {CreateButton("", "icon row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
                                                        </div>
                                                    </div>
                                                    <div className="timeTable container">
                                                        <CreateTable
                                                            dataList={dateTimeRecordData}
                                                            dataHeader={uploadTimeEntriesHeader}
                                                            dataAccessor={uploadTimeEntriesaccessor}
                                                            editHandleClick={editHandleClick}
                                                            deleteHandleClick={deleteHandleClick}
                                                            activeRowIds={activeRowIds}
                                                            setActiveRowIds={setActiveRowIds}
                                                            currentPage={currentPage}
                                                            setCurrentPage={setCurrentPage}
                                                            setSelected={setSelectedDTR}
                                                            isSelectAll={isSelectAll}
                                                            setIsSelectAll={setIsSelectAll}
                                                        />
                                                        {dateTimeRecordData.length > 0 ? (
                                                            <div></div>
                                                        )
                                                        :
                                                        (
                                                            
                                                            <div> {/*<p>No records to display</p>*/}</div>
                                                        )}
                                                    </div>
                                                </>
                                            </div>
                                        </>
                                    </TabPanel>

                                    <TabPanel>
                                        <>
                                            <div style={{marginTop: "20px"}}>
                                                {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilterProcessed(e.target.value), 
                                                                        "Search by name", 
                                                                        SearchIcon)}
                                            </div>
                                            <div className="transaction-body" style={{padding: "0", marginTop: "20px"}}>
                                                <>
                                                    <div className="timeTable container">
                                                        <CreateTable
                                                            dataList={dateTimeRecordDataProcessed}
                                                            dataHeader={uploadTimeEntriesHeader}
                                                            dataAccessor={uploadTimeEntriesaccessor}
                                                            editHandleClick={editHandleClick}
                                                            deleteHandleClick={deleteHandleClick}
                                                            activeRowIds={activeRowIds}
                                                            setActiveRowIds={setActiveRowIds}
                                                            currentPage={currentPage}
                                                            setCurrentPage={setCurrentPage}
                                                            setSelected={setSelectedDTR}
                                                            isSelectAll={isSelectAll}
                                                            setIsSelectAll={setIsSelectAll}
                                                        />
                                                        {dateTimeRecordDataProcessed.length > 0 ? (
                                                            <div></div>
                                                        )
                                                        :
                                                        (
                                                            
                                                            <div> {/*<p>No records to display</p>*/}</div>
                                                        )}
                                                    </div>
                                                </>
                                            </div>
                                        </>
                                    </TabPanel>
                                </div>
                            </Tabs>

                            <>
                                <div style={{marginTop: "20px"}}>
                                    {CreateSearchBarWithPlaceHolder("", 
                                                            "mainte-search row", 
                                                            "mainte-search-icon", 
                                                            "mainte-search-input", 
                                                            (e) => handleFilter(e.target.value), 
                                                            "Search by name", 
                                                            SearchIcon)}
                                </div>
                                <div className="transaction-body" style={{padding: "0"}}>
                                    <>
                                        <div className="timeBtns row">
                                            <div className="timeBtn add row">
                                                {CreateButton("", "icon row", addHandleClick, "ADD", AddIcon)}
                                            </div>
                                            <div className="timeBtn extract row">
                                                {CreateButton("", "icon row", exportToExcel, "EXTRACT", FileCopyIcon)}
                                            </div>
                                            <div className="timeBtn download row">
                                                {CreateButton("", "icon row", generateDownloadTemplate, "DOWNLOAD TEMPLATE", DownloadIcon)}
                                            </div>
                                            <div className="timeBtn extract row">
                                                {CreateButton("", "icon row", openUploadFormHandleClick, "UPLOAD DTR", FileUploadIcon)}
                                            </div>
                                            <div className="timeBtn delete row">
                                                {CreateButton("", "icon row", openDeleteAll, "DELETE DTR", DeleteForeverIcon)}
                                            </div>
                                            <div className="timeBtn download row">
                                                {CreateButton("", "icon row", openPostTimeForm, "POST DTR", PostAddIcon)}
                                            </div>
                                            <div className="timeBtn approve row" style={{display: "none"}}>
                                                {CreateButton("", "icon row", ()=>setShowApproveForm(true), "APPROVE", DoneIcon)}
                                            </div>
                                            <div className="timeBtn approve row" style={{display: "none"}}>
                                                {CreateButton("", "icon row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
                                            </div>
                                        </div>
                                        <div className="timeTable container">
                                            <CreateTable
                                                dataList={dateTimeRecordData}
                                                dataHeader={uploadTimeEntriesHeader}
                                                dataAccessor={uploadTimeEntriesaccessor}
                                                editHandleClick={editHandleClick}
                                                deleteHandleClick={deleteHandleClick}
                                                activeRowIds={activeRowIds}
                                                setActiveRowIds={setActiveRowIds}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                setSelected={setSelectedDTR}
                                                isSelectAll={isSelectAll}
                                                setIsSelectAll={setIsSelectAll}
                                            />
                                            {dateTimeRecordData.length > 0 ? (
                                                <div></div>
                                            )
                                            :
                                            (
                                                
                                                <div> {/*<p>No records to display</p>*/}</div>
                                            )}
                                        </div>
                                    </>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    timeIn={timeIn} 
                    setTimeIn={setTimeIn}
                    deviceNameTimeIn={deviceNameTimeIn}
                    setDeviceNameTimeIn={setDeviceNameTimeIn}
                    timeOut={timeOut}
                    setTimeOut={setTimeOut}
                    deviceNameTimeOut={deviceNameTimeOut}
                    setDeviceNameTimeOut={setDeviceNameTimeOut}
                    setShowEmployeeForm={setShowEmployeeForm}
                    reasonForTampering={reasonForTampering} 
                    setReasonForTampering={setReasonForTampering}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    timeIn={timeIn} 
                    setTimeIn={setTimeIn}
                    deviceNameTimeIn={deviceNameTimeIn}
                    setDeviceNameTimeIn={setDeviceNameTimeIn}
                    timeOut={timeOut}
                    setTimeOut={setTimeOut}
                    deviceNameTimeOut={deviceNameTimeOut}
                    setDeviceNameTimeOut={setDeviceNameTimeOut}
                    reasonForTampering={reasonForTampering}
                    setReasonForTampering={setReasonForTampering}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <RevertTimeEntriesForm  isOpen={showRevertTimeForm} 
                    onClose={closeRevertTimeForm}
                    fetchUploads={fetchDataTimeEntries}
                    fetchDataProcessed={fetchDataProcessed}
                    // fetchProcessedSummary={fetchDataSummaryProcessed}
                    // fetchProcessedDetailed={fetchDataDetailedProcessed}
                    // fetchPostedSummary={fetchDataSummaryPosted}
                    // fetchPostedDetailed={fetchDataDetailedPosted}
                    // setIsRevert={setIsRevert}
                    user={user}

                    loadingRequest={loading}
                    setLoadingRequest={setLoading}
            >
            </RevertTimeEntriesForm>
            <ProcessTimeEntriesForm  isOpen={showProcessTimeForm} 
                    onClose={closeProcessTimeForm}
                    fetchUploads={fetchDataTimeEntries}
                    fetchDataProcessed={fetchDataProcessed}
                    // fetchProcessedSummary={fetchDataSummaryProcessed}
                    // fetchProcessedDetailed={fetchDataDetailedProcessed}
                    // fetchPostedSummary={fetchDataSummaryPosted}
                    // fetchPostedDetailed={fetchDataDetailedPosted}
                    // setIsProcess={setIsProcess}
                    user={user}

                    loadingRequest={loading}
                    setLoadingRequest={setLoading}
            >
            </ProcessTimeEntriesForm>
            <PostTimeEntriesForm  isOpen={showPostTimeForm} 
                    onClose={closePostTimeForm}
                    fetchUploads={fetchDataTimeEntries}
                    fetchDataProcessed={fetchDataProcessed}
                    // fetchProcessedSummary={fetchDataSummaryProcessed}
                    // fetchProcessedDetailed={fetchDataDetailedProcessed}
                    // fetchPostedSummary={fetchDataSummaryPosted}
                    // fetchPostedDetailed={fetchDataDetailedPosted}
                    // setIsPost={setIsPost}
                    user={user}

                    loadingRequest={loading}
                    setLoadingRequest={setLoading}
            >
            </PostTimeEntriesForm>
            <DeleteAllForm  isOpen={showDeleteAll} 
                    onClose={closeDeleteAll}
                    fetchUploads={fetchDataTimeEntries}
                    fetchDataProcessed={fetchDataProcessed}
                    loadingRequest={loading}
                    setLoadingRequest={setLoading}
                    // handleDelete={handleDeleteAll}
            >
            </DeleteAllForm>
            <EmployeeSelectFormLogs  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    // setEmployeeInfo={setEmployeeInfoLogs}
            >
            </EmployeeSelectFormLogs>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <ApproveForm  isOpen={showApproveForm} 
                    onClose={closeApproveHandleClick}
                    handleApprove={approveHandleClick}
            >
            </ApproveForm>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            { loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}
function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
    openDeleteFormHandleClick,
    openRevertTimeForm,
    openProcessTimeForm,
    openPostTimeForm,
}){
    const handleUploadClick = () =>{
        openUploadFormHandleClick();
    }
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>handleUploadClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Time Entries
            </div>
            <div className="payroll-setting-item row"onClick={()=>openDeleteFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><DeleteSweepIcon/></div>
                Delete Uploaded Entries
            </div>
            <div className="payroll-setting-item row" onClick={()=>openRevertTimeForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><SettingsBackupRestoreIcon/></div>
                Revert Time Entries
            </div>
            <div className="payroll-setting-item row" onClick={()=>openProcessTimeForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ffaa00"}}><AccountTreeIcon/></div>
                Process Time Entries
            </div>
            <div className="payroll-setting-item row" onClick={()=>openPostTimeForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><PostAddIcon/></div>
                Post Time Entries
            </div>
        </div>
    )
}
function AddForm({
    isOpen, 
    onClose,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    timeIn,
    setTimeIn,
    deviceNameTimeIn,
    setDeviceNameTimeIn,
    timeOut,
    setTimeOut,
    deviceNameTimeOut,
    setDeviceNameTimeOut,
    setShowEmployeeForm,
    reasonForTampering,
    setReasonForTampering,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId
        || !timeIn
        // || !deviceNameTimeIn
        || !timeOut
        || !reasonForTampering
        // || !deviceNameTimeOut
    ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setTimeIn("");
        setDeviceNameTimeIn("");
        setTimeOut("");
        setDeviceNameTimeOut("");
        setReasonForTampering("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Time Entry</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeIn} setDate={setTimeIn}/>
                            </div>
                            <span style={{
                                        visibility: !timeIn && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeOut} setDate={setTimeOut}/>
                            </div>
                            <span style={{
                                        visibility: !timeOut && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column"  style={{display: "none"}}>
                            <div className="info-item-label">Time Out Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason For Tampering</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonForTampering}
                                        onChange={(e)=>setReasonForTampering(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !reasonForTampering && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    timeIn,
    setTimeIn,
    deviceNameTimeIn,
    setDeviceNameTimeIn,
    timeOut,
    setTimeOut,
    deviceNameTimeOut,
    setDeviceNameTimeOut,
    reasonForTampering,
    setReasonForTampering,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId
            || !timeIn
            // || !deviceNameTimeIn
            || !timeOut
            // || !deviceNameTimeOut
            || !reasonForTampering
        ){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setTimeIn("");
        setDeviceNameTimeIn("");
        setTimeOut("");
        setDeviceNameTimeOut("");
        setReasonForTampering("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Time Entry</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        style={{cursor:"not-allowed"}}
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeIn} setDate={setTimeIn}/>
                            </div>
                            <span style={{
                                        visibility: !timeIn && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeOut} setDate={setTimeOut}/>
                            </div>
                            <span style={{
                                        visibility: !timeOut && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Time Out Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason For Tampering</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonForTampering}
                                        onChange={(e)=>setReasonForTampering(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !reasonForTampering && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Time Entries"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function DeleteAllForm({isOpen, 
    onClose, 
    fetchUploads,
    fetchDataProcessed,
    loadingRequest,
    setLoadingRequest
}
){
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleDelete(e);
        setErrorState(false);
        // setIsRevert(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/DTRCorrectionWorkerStaging`);
    
    const handleDelete = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/delete`;

        try {
            setLoadingRequest(true);
    
            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await fetchUploads();
            await fetchDataProcessed();

            setShowRequestMessage(true);
            setIsSuccess(true);

            handleClose();
        } catch (error) {
            setLoadingRequest(false); // Set the loading state to false

            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state
        } finally {
            setLoadingRequest(false);
        }
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete Time Entries!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                            </div>
                            <span style={{
                                        visibility: !classificationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </>
    );
}
function RevertTimeEntriesForm({isOpen, 
    onClose,
    fetchUploads,
    fetchDataProcessed,
    // fetchProcessedSummary,
    // fetchProcessedDetailed,
    // fetchPostedSummary,
    // fetchPostedDetailed,
    // setIsRevert,
    user,

    loadingRequest,
    setLoadingRequest,
    loadingPercentage, 
    setLoadingPercentage
}){
    // const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleRevert(e);
        setErrorState(false);
        // setIsRevert(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/DTRCorrectionWorkerStaging`);
    
    const handleRevert = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/revert`;

        try {
            setLoadingRequest(true);
    
            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchUploads();
            await fetchDataProcessed();
            // await fetchProcessedSummary();
            // await fetchProcessedDetailed();
            // await fetchPostedSummary();
            // await fetchPostedDetailed();

            setShowRequestMessage(true);
            setIsSuccess(true);

            handleClose();
        } catch (error) {
            setLoadingRequest(false); // Set the loading state to false

            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state
        } finally {
            setLoadingRequest(false);
        }
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Revert Time Entries</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId}/>
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                            </div>
                            <span style={{
                                        visibility: !classificationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                REVERT
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function ProcessTimeEntriesForm({isOpen, 
    onClose,
    fetchUploads,
    fetchDataProcessed,
    // fetchProcessedSummary,
    // fetchProcessedDetailed,
    // fetchPostedSummary,
    // fetchPostedDetailed,
    // setIsProcess,
    user,

    loadingRequest,
    setLoadingRequest,
    loadingPercentage, 
    setLoadingPercentage
}){
    // const [loadingRequest, setLoadingRequest] = useState(false);
    // const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleProcess(e);
        setErrorState(false);
        // setIsProcess(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };

    const apiUrlRef = useRef( domain + `/api/DTRCorrectionWorkerStaging`);
    
    const handleProcess = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}`;
    
        try {
            setLoadingRequest(true);
    
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await fetchUploads();
            await fetchDataProcessed();
            // await fetchProcessedSummary();
            // await fetchProcessedDetailed();
            // await fetchPostedSummary();
            // await fetchPostedDetailed();
    
            setShowRequestMessage(true);
            setIsSuccess(true);
    
            handleClose();
        } catch (error) {
            setLoadingRequest(false); // Set the loading state to false
    
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
    
            // Safeguard in case the error structure is different
            const errorMessage = error?.response?.data?.message || 'An error occurred during processing.';
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Process Time Entries</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId}/>
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                            </div>
                            <span style={{
                                        visibility: !classificationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                PROCESS
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                    <p>{`Loading: ${loadingPercentage}%`}</p>
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function PostTimeEntriesForm({isOpen, 
    onClose,
    fetchUploads,
    fetchDataProcessed,
    // fetchProcessedSummary,
    // fetchProcessedDetailed,
    // fetchPostedSummary,
    // fetchPostedDetailed,
    // setIsPost,
    user,

    loadingRequest,
    setLoadingRequest,
    loadingPercentage, 
    setLoadingPercentage
}){
    // const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handlePost(e);
        setErrorState(false);
        // setIsPost(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/DTRCorrectionWorker`);
    
    const handlePost = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/post`;

        try {
            setLoadingRequest(true);

            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchUploads();
            await fetchDataProcessed();
            // await fetchProcessedSummary();
            // await fetchProcessedDetailed();
            // await fetchPostedSummary();
            // await fetchPostedDetailed();

            setShowRequestMessage(true);
            setIsSuccess(true);

            handleClose();
        } catch (error) {
            setLoadingRequest(false); // Set the loading state to false
    
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state
        } finally {
            setLoadingRequest(false);
        }
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Post Time Entries</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                            </div>
                            <span style={{
                                        visibility: !classificationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                POST
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function ApproveForm({isOpen, 
    onClose, 
    handleApprove}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Approval!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to approve selected record/s?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleApprove}
                            style={{marginRight:"5px"}}>
                                APPROVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="datetime-local"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function TimeDevice({device, setDevice}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDevice(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Device";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(device !== "" && device !== 0 && device !== null && device !== undefined){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [device]);

    return (
        <div>
            <select id="" className="filterSelect" value={device} onChange={handleSelectChange} style={{color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose a device</option>
                {data.map((device) => ( 
                    SetTimeDevice(device)
                ))}
            </select>
        </div>
    );
};
function SetTimeDevice(device){
    return(
        <option value={device.name}>{
            device.name}
        </option>
    )
}
function EmployeeSelectFormLogs({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    setEmployeeInfo
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        // setEmployeeInfo(selectedEmployee);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilterLogs setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilterLogs({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
export function CreateTable({
    dataList = [],
    dataHeader = [],
    dataAccessor = [],
    currentPage,
    setCurrentPage,
    editHandleClick,
    deleteHandleClick,
    setSelected,
    employees,
    isSelectAll,
    setIsSelectAll,
    activeRowIds,
    setActiveRowIds
}) {
    const itemsPerPage = 10;

    // Define table columns
    const columns = React.useMemo(
        () =>
            dataHeader.map((header, index) => ({
                Header: header,
                accessor: dataAccessor[index],
            })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Select all logic
    useEffect(() => {
        if (isSelectAll) {
            const newActiveRowIds = rows.map((item) => item.original.id);
            const newActiveRowOriginal = rows.map((item) => item.original);
            setActiveRowIds(newActiveRowIds);
            setSelected(newActiveRowOriginal);
            setIsSelectAll(false);
        }
    }, [isSelectAll, setIsSelectAll, setSelected, rows, setActiveRowIds]);

    // Row click handler
    const handleRowClick = (rowData) => {
        setSelected((prevSelected) => {
            const isAlreadySelected = prevSelected.some(
                (item) => item.id === rowData.id
            );
            return isAlreadySelected
                ? prevSelected.filter((item) => item.id !== rowData.id)
                : [...prevSelected, rowData];
        });

        setActiveRowIds((prevIds) =>
            prevIds.includes(rowData.id)
                ? prevIds.filter((id) => id !== rowData.id)
                : [...prevIds, rowData.id]
        );
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className="scrollable-table">
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps()}
                                        onClick={() => headerClick(column)}
                                        className="sortable-header"
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row);
                            return (
                                <tr
                                    key={row.original.id}
                                    {...row.getRowProps()}
                                    onClick={() =>
                                        handleRowClick(row.original)
                                    }
                                    className={
                                        activeRowIds.includes(row.original.id)
                                            ? "active"
                                            : ""
                                    }
                                    /* id={
                                        row.original.reasonForTampering
                                            ? "tampered"
                                            : ""
                                    } */
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo
                                            header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                        />
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {rows.length > itemsPerPage ? (
                <>
                    <div
                        className="table-page row"
                        style={{
                            alignItems: "center",
                            justifyContent: "end",
                            padding: "20px 0 0 0",
                        }}
                    >
                        <button
                            className="prev row"
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility:
                                    currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            &lt;&lt;
                        </button>
                        <button
                            className="prev row"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility:
                                    currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            PREVIOUS
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={indexOfLastItem >= rows.length}
                            style={{
                                visibility:
                                    rows.length > itemsPerPage && !isLastPage
                                        ? "visible"
                                        : "hidden",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            NEXT
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(totalPages)}
                            disabled={indexOfLastItem >= rows.length}
                            style={{
                                visibility:
                                    rows.length > itemsPerPage && !isLastPage
                                        ? "visible"
                                        : "hidden",
                                height: "26px",
                            }}
                        >
                            &gt;&gt;
                        </button>
                    </div>
                    {`${currentPage}/${totalPages}`}
                </>
            ) : (
                <></>
            )}
        </>
    );
}
export function CreateTableForEmployeeSelect({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, setSelectedEmployee}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleRowClick = (rowData) => {
        setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    };

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            className={row.original.id === activeRowId ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header} 
                                        _cell={cell}/>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px"}}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px"}}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div style={{textAlign:"center"}}>{`${currentPage}/${totalPages}`}</div>
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, _cell, editHandleClick, deleteHandleClick}) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    /* if (header === "Device") {
        return (
            <td></td>
        )
    } */

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Days"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};

function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function PayrollPeriodIdSelectFilter({payrollPeriodId, setPayrollPeriodId, payTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        if(!payTypeId){
            return;
        }
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active/paytype/${payTypeId}`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [payTypeId]);

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [fetchData, payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={!payTypeId} value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose payroll period</option>
                {data.map((payrollPeriodId) => ( 
                    SetPayrollPeriodId(payrollPeriodId)
                ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function PayTypeIdSelect({payTypeId, setPayTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayTypeId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payTypeId !== "" && payTypeId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose pay type</option>
            {data.map((payTypeId) => ( 
                SetPayTypeId(payTypeId)
            ))}
            </select>
        </div>
    );
};
function SetPayTypeId(payTypeId){
    return(
        <option value={payTypeId.id}>{
            payTypeId.description}
        </option>
    )
    
}
function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAll1({classificationId, setClassificationId, setActiveRowIds, setSelectedDTR}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedDTR){
            setActiveRowIds([]);
            setSelectedDTR([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose classification</option>
                {data.length > 0 && <option value="0">All</option>}
                {data.map((classificationId) => ( 
                    SetClassificationId(classificationId)
                ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function SectionIdSelect({sectionId, setSectionId}){
    
    const handleSelectChange = (event) => {
        setSectionId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Section/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={sectionId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((sectionId) => ( 
                SetSectionId(sectionId)
            ))}
            </select>
        </div>
    );
};
function SetSectionId(sectionId){
    return(
        <option value={sectionId.id}>{
            sectionId.description}
        </option>
    )
    
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export default DTRCorrectionWorkers
